import { _ as _objectWithoutProperties, a as _objectSpread2, w as withTestId, b as _taggedTemplateLiteral, c as _defineProperty, d as _slicedToArray } from '../../dist/ProgressiveLoader-1f159f7e.esm.js';
import { forwardRef, useStyleConfig, chakra, useMultiStyleConfig, Center, omitThemingProps } from '@chakra-ui/react';
import { mapResponsive, theme } from '@hover/chakra-theme';
import { MotionConfig, AnimatePresence, motion as motion$1 } from 'framer-motion';
import { useState, useEffect } from 'react';
import { I as Icon, g as getVariants, L as Link$1 } from '../../dist/Link-f27d7a31.esm.js';
import { css, keyframes } from '@emotion/react';
import { iLoaderClockwise } from '@hover/icons';
import 'ramda/src/omit';
import 'ramda/src/pick';
import '@chakra-ui/system';
import 'ramda/src/has';
import 'tiny-warning';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';
import '@hover/utilities';
import 'ramda/src/mapObjIndexed';
import 'ramda/src/join';
import 'ramda/src/identity';
import 'ramda/src/ifElse';
import 'ramda/src/map';
import 'ramda/src/split';
import 'ramda/src/concat';
import 'ramda/src/toLower';
import 'ramda/src/pipe';
import { motion } from '@hover/chakra-theme/foundation';
import '@hover/chakra-theme/next';
import 'ramda/src/mergeDeepLeft';
import 'ramda/src/mergeLeft';
import '@hover/chakra-theme/components';
import '@hover/tokens-typography';
import '@hover/tokens-typography/next';
import '@hover/chakra-theme/bauhaus';
import 'tiny-invariant';
import '@hover/icons/constants';
import 'polished';
import '@chakra-ui/react-utils';

/* eslint-disable @typescript-eslint/no-redeclare */

var Copy = {
  LOADING: 'Loading'
};
var ProgressBarValue = {
  MAX: 100,
  MIN: 0
};

var _excluded$5 = ["label", "color", "speed"];
var _templateObject;
var LINE_COUNT = 8;
var durations = {
  100: 2,
  200: 1,
  300: 0.5
};
var fade = /*#__PURE__*/keyframes(_templateObject || (_templateObject = /*#__PURE__*/_taggedTemplateLiteral(["\n  0% {\n     opacity: 0.25;\n     stroke-dashoffset: 7px;\n   }\n\n  25% {\n    opacity: 1;\n    stroke-dashoffset: 10px;\n  }\n\n  100% {\n    opacity: 0.25;\n    stroke-dashoffset: 7px\n   }\n"])));
var Spinner = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$label = _ref.label,
    label = _ref$label === void 0 ? Copy.LOADING : _ref$label,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'primary.600' : _ref$color,
    _ref$speed = _ref.speed,
    speed = _ref$speed === void 0 ? 200 : _ref$speed,
    props = _objectWithoutProperties(_ref, _excluded$5);
  var duration = durations[speed];
  var styles = /*#__PURE__*/css([/*#__PURE__*/css("& line{stroke-width:2.25px;animation:", fade, " ", duration, "s linear infinite;stroke-dashoffset:5px;stroke-dasharray:5px;}" + (process.env.NODE_ENV === "production" ? "" : ";label:styles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), Array.from({
    length: LINE_COUNT
  }).map(function (_, index) {
    return index + 1;
  }).map(function (n) {
    return /*#__PURE__*/css("line:nth-of-type(", n, "){animation-delay:-", duration - duration / LINE_COUNT * n, "s;}" + (process.env.NODE_ENV === "production" ? "" : ";label:styles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlNwaW5uZXIudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWlFa0IiLCJmaWxlIjoiU3Bpbm5lci50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBSZXNwb25zaXZlVmFsdWUsIGZvcndhcmRSZWYgfSBmcm9tICdAY2hha3JhLXVpL3JlYWN0JztcbmltcG9ydCB7IGNzcywga2V5ZnJhbWVzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgU3Bpbm5lclNpemUgfSBmcm9tICdAaG92ZXIvY2hha3JhLXRoZW1lL2NvbXBvbmVudHMnO1xuaW1wb3J0IHsgaUxvYWRlckNsb2Nrd2lzZSBhcyBpTG9hZGVyIH0gZnJvbSAnQGhvdmVyL2ljb25zJztcbmltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5cbmltcG9ydCB7IHdpdGhUZXN0SWQgfSBmcm9tICcuLi8uLi8uLi9oZWxwZXJzJztcbmltcG9ydCB7IEljb24sIEljb25Qcm9wcyB9IGZyb20gJy4uLy4uL0ljb24nO1xuaW1wb3J0IHsgQmFzZVByb3BzIH0gZnJvbSAnLi4vLi4vdHlwZXMnO1xuXG5pbXBvcnQgeyBDb3B5LCBQcm9ncmVzc0JhclZhbHVlIH0gZnJvbSAnLi90eXBlcyc7XG5cbmV4cG9ydCB0eXBlIFNwaW5uZXJTcGVlZCA9IDEwMCB8IDIwMCB8IDMwMDtcblxuZXhwb3J0IGludGVyZmFjZSBTcGlubmVyUHJvcHNcbiAgZXh0ZW5kcyBCYXNlUHJvcHMsXG4gICAgT21pdDxJY29uUHJvcHMsICdpY29uJyB8ICdzaXplJz4ge1xuICBsYWJlbD86IHN0cmluZztcbiAgc3BlZWQ/OiBTcGlubmVyU3BlZWQ7XG4gIHNpemU/OiBSZXNwb25zaXZlVmFsdWU8U3Bpbm5lclNpemU+O1xufVxuXG5jb25zdCBMSU5FX0NPVU5UID0gODtcblxuY29uc3QgZHVyYXRpb25zOiB7IFtTIGluIFNwaW5uZXJTcGVlZF06IG51bWJlciB9ID0ge1xuICAxMDA6IDIsXG4gIDIwMDogMSxcbiAgMzAwOiAwLjUsXG59IGFzIGNvbnN0O1xuXG5jb25zdCBmYWRlID0ga2V5ZnJhbWVzYFxuICAwJSB7XG4gICAgIG9wYWNpdHk6IDAuMjU7XG4gICAgIHN0cm9rZS1kYXNob2Zmc2V0OiA3cHg7XG4gICB9XG5cbiAgMjUlIHtcbiAgICBvcGFjaXR5OiAxO1xuICAgIHN0cm9rZS1kYXNob2Zmc2V0OiAxMHB4O1xuICB9XG5cbiAgMTAwJSB7XG4gICAgb3BhY2l0eTogMC4yNTtcbiAgICBzdHJva2UtZGFzaG9mZnNldDogN3B4XG4gICB9XG5gO1xuXG5jb25zdCBTcGlubmVyID0gZm9yd2FyZFJlZjxTcGlubmVyUHJvcHMsICdzdmcnPihcbiAgKFxuICAgIHsgbGFiZWwgPSBDb3B5LkxPQURJTkcsIGNvbG9yID0gJ3ByaW1hcnkuNjAwJywgc3BlZWQgPSAyMDAsIC4uLnByb3BzIH0sXG4gICAgcmVmLFxuICApID0+IHtcbiAgICBjb25zdCBkdXJhdGlvbiA9IGR1cmF0aW9uc1tzcGVlZF07XG4gICAgY29uc3Qgc3R5bGVzID0gY3NzKFtcbiAgICAgIGNzc2BcbiAgICAgICAgJiBsaW5lIHtcbiAgICAgICAgICBzdHJva2Utd2lkdGg6IDIuMjVweDtcbiAgICAgICAgICBhbmltYXRpb246ICR7ZmFkZX0gJHtkdXJhdGlvbn1zIGxpbmVhciBpbmZpbml0ZTtcbiAgICAgICAgICBzdHJva2UtZGFzaG9mZnNldDogNXB4O1xuICAgICAgICAgIHN0cm9rZS1kYXNoYXJyYXk6IDVweDtcbiAgICAgICAgfVxuICAgICAgYCxcbiAgICAgIEFycmF5LmZyb20oeyBsZW5ndGg6IExJTkVfQ09VTlQgfSlcbiAgICAgICAgLm1hcCgoXywgaW5kZXgpID0+IGluZGV4ICsgMSlcbiAgICAgICAgLm1hcChcbiAgICAgICAgICBuID0+IGNzc2BcbiAgICAgICAgICAgIGxpbmU6bnRoLW9mLXR5cGUoJHtufSkge1xuICAgICAgICAgICAgICBhbmltYXRpb24tZGVsYXk6IC0ke2R1cmF0aW9uIC0gKGR1cmF0aW9uIC8gTElORV9DT1VOVCkgKiBufXM7XG4gICAgICAgICAgICB9XG4gICAgICAgICAgYCxcbiAgICAgICAgKSxcbiAgICBdKTtcblxuICAgIHJldHVybiAoXG4gICAgICA8SWNvblxuICAgICAgICB7Li4ud2l0aFRlc3RJZChwcm9wcyl9XG4gICAgICAgIGFsaWduQ29udGVudD1cImNlbnRlclwiXG4gICAgICAgIGFyaWEtYnVzeVxuICAgICAgICBhcmlhLWhpZGRlbj1cImZhbHNlXCJcbiAgICAgICAgYXJpYS1sYWJlbD17bGFiZWx9XG4gICAgICAgIGFyaWEtdmFsdWVtYXg9e1Byb2dyZXNzQmFyVmFsdWUuTUFYfVxuICAgICAgICBhcmlhLXZhbHVlbWluPXtQcm9ncmVzc0JhclZhbHVlLk1JTn1cbiAgICAgICAgY29sb3I9e2NvbG9yfVxuICAgICAgICBjc3M9e3N0eWxlc31cbiAgICAgICAgaWNvbj17aUxvYWRlcn1cbiAgICAgICAganVzdGlmeUNvbnRlbnQ9XCJjZW50ZXJcIlxuICAgICAgICByZWY9e3JlZn1cbiAgICAgICAgcm9sZT1cInByb2dyZXNzYmFyXCJcbiAgICAgIC8+XG4gICAgKTtcbiAgfSxcbik7XG5cbmV4cG9ydCB7IFNwaW5uZXIgfTtcbiJdfQ== */");
  })], process.env.NODE_ENV === "production" ? "" : ";label:styles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
  return jsx(Icon, _objectSpread2(_objectSpread2({}, withTestId(props)), {}, {
    alignContent: "center",
    "aria-busy": true,
    "aria-hidden": "false",
    "aria-label": label,
    "aria-valuemax": ProgressBarValue.MAX,
    "aria-valuemin": ProgressBarValue.MIN,
    color: color,
    css: styles,
    icon: iLoaderClockwise,
    justifyContent: "center",
    ref: ref,
    role: "progressbar"
  }));
});

var _excluded$4 = ["size", "decoration", "orientation", "state"];
var shapeTransitions = /*#__PURE__*/['transform', 'stroke-width', 'fill'].map(function (t) {
  return "".concat(t, " ").concat(motion.easings[150]);
}).join(',');
var Decoration = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'small' : _ref$size,
    DecorationComponent = _ref.decoration;
    _ref.orientation;
    var _ref$state = _ref.state,
    state = _ref$state === void 0 ? 'idle' : _ref$state,
    props = _objectWithoutProperties(_ref, _excluded$4);
  var styles = useStyleConfig('Decoration', {
    size: size
  });
  return jsx(chakra.svg, _objectSpread2(_objectSpread2({
    "aria-hidden": "true",
    as: DecorationComponent,
    className: "blueprint-decoration",
    role: "img",
    transition: "color ".concat(motion.easings[250], ", ").concat(shapeTransitions)
  }, withTestId(props)), {}, {
    __css: styles,
    ref: ref,
    state: state
  }));
});
Decoration.displayName = 'Decoration';

var renderDecorationOrIcon = function renderDecorationOrIcon(_ref) {
  var _spacing;
  var position = _ref.position,
    decoration = _ref.decoration,
    decorationSize = _ref.decorationSize,
    icon = _ref.icon,
    iconSize = _ref.iconSize,
    isOver = _ref.isOver,
    __css = _ref.__css;
  var spacing = (_spacing = {
    margin: 0
  }, _defineProperty(_spacing, position === 'after' ? 'marginRight' : 'marginLeft', '-100'), _defineProperty(_spacing, position === 'before' ? 'marginRight' : 'marginLeft', '200'), _spacing);
  if (decoration && decorationSize) return jsx(Decoration, _objectSpread2(_objectSpread2({
    decoration: decoration,
    size: decorationSize,
    state: isOver ? 'hover' : 'idle'
  }, spacing), {}, {
    __css: __css
  }));
  if (icon && iconSize) return jsx(Icon, _objectSpread2({
    icon: icon,
    size: iconSize
  }, spacing));
  return null;
};

var _excluded$3 = ["children", "decorationAfter", "decorationBefore", "iconAfter", "iconBefore", "isLoading", "size"];
var iconSizes$1 = {
  small: 'tiny',
  medium: 'small',
  large: 'medium'
};
var spinnerSizes = {
  small: 'small',
  medium: 'medium',
  large: 'large'
};
var decorationSizes$1 = {
  small: 'small',
  medium: 'medium',
  large: 'large'
};
var MotionCenter = /*#__PURE__*/motion$1(Center);
var MotionSpinner = /*#__PURE__*/motion$1(Spinner);
var Button = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    decorationAfter = _ref.decorationAfter,
    decorationBefore = _ref.decorationBefore,
    iconAfter = _ref.iconAfter,
    iconBefore = _ref.iconBefore,
    isLoading = _ref.isLoading,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded$3);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOver = _useState2[0],
    setIsOver = _useState2[1];
  var styles = useMultiStyleConfig('BrandButton', _objectSpread2({
    size: size
  }, props));
  var iconSize = mapResponsive(function (s) {
    return iconSizes$1[s];
  }, size, 'small');
  var spinnerSize = mapResponsive(function (s) {
    return spinnerSizes[s];
  }, size, 'medium');
  var decorationSize = mapResponsive(function (s) {
    return decorationSizes$1[s];
  }, size, 'medium');
  var iconOrDecorationProps = {
    decorationSize: decorationSize,
    iconSize: iconSize,
    isOver: isOver,
    __css: styles.decoration
  };
  return jsx(chakra.button, _objectSpread2(_objectSpread2({}, omitThemingProps(props)), {}, {
    __css: styles.button,
    onMouseEnter: function onMouseEnter() {
      return setIsOver(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setIsOver(false);
    },
    ref: ref,
    children: jsx(Center, {
      className: "blueprint-brand--button-wrapper",
      height: "100%",
      overflow: "hidden",
      children: jsxs(MotionConfig, {
        transition: theme.motion.framer.tight,
        children: [jsxs(MotionCenter, {
          __css: styles.content,
          animate: isLoading ? 'loading' : 'idle',
          className: "blueprint-brand--button-content",
          height: "100%",
          variants: getVariants(true, false),
          width: "100%",
          children: [renderDecorationOrIcon(_objectSpread2({
            position: 'before',
            decoration: decorationBefore,
            icon: iconBefore
          }, iconOrDecorationProps)), children, renderDecorationOrIcon(_objectSpread2({
            position: 'after',
            decoration: decorationAfter,
            icon: iconAfter
          }, iconOrDecorationProps))]
        }), jsx(AnimatePresence, {
          children: isLoading && jsx(MotionSpinner, {
            animate: "loading",
            color: "inherit",
            exit: "idle",
            initial: "idle",
            position: "absolute",
            size: spinnerSize,
            variants: getVariants(true, true)
          })
        })]
      })
    })
  }));
});

var _excluded$2 = ["children", "decorationAfter", "decorationBefore", "iconAfter", "iconBefore", "size", "isOver"];
var iconSizes = {
  200: 'tiny',
  300: 'tiny',
  400: 'small',
  500: 'small',
  600: 'medium'
};
var decorationSizes = {
  200: 'tiny',
  300: 'tiny',
  400: 'small',
  500: 'medium',
  600: 'medium'
};
var Link = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    decorationAfter = _ref.decorationAfter,
    decorationBefore = _ref.decorationBefore,
    iconAfter = _ref.iconAfter,
    iconBefore = _ref.iconBefore,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 500 : _ref$size,
    isOverProp = _ref.isOver,
    props = _objectWithoutProperties(_ref, _excluded$2);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOverState = _useState2[0],
    setIsOver = _useState2[1];
  var isOver = isOverProp !== null && isOverProp !== void 0 ? isOverProp : isOverState;

  // FIXME: switch to dedicated component theme
  var styles = useMultiStyleConfig('BrandButton', props);
  var iconSize = mapResponsive(function (s) {
    return iconSizes[s];
  }, size, 'small');
  var decorationSize = mapResponsive(function (s) {
    return decorationSizes[s];
  }, size, 'medium');
  var iconOrDecorationProps = {
    decorationSize: decorationSize,
    iconSize: iconSize,
    isOver: isOver,
    __css: styles.decoration
  };
  return jsxs(Link$1, _objectSpread2(_objectSpread2(_objectSpread2({
    alignItems: "center",
    display: "inline-flex"
  }, props), isOverProp === true ? {
    'data-hover': 'true'
  } : {}), {}, {
    onMouseEnter: function onMouseEnter() {
      return setIsOver(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setIsOver(false);
    },
    ref: ref,
    children: [renderDecorationOrIcon(_objectSpread2({
      position: 'before',
      decoration: decorationBefore,
      icon: iconBefore
    }, iconOrDecorationProps)), children, renderDecorationOrIcon(_objectSpread2({
      position: 'after',
      decoration: decorationAfter,
      icon: iconAfter
    }, iconOrDecorationProps))]
  }));
});

var _excluded$1 = ["state"];
var ARROW_BODY_RIGHT = 'M20.25 11.9985L33.7469 11.9985';
var ARROW_BODY_STRETCH = 'M5.25 11.9985L33.7469 11.9985';
var ARROW_BODY = 'M5.25 11.9985L18.7469 11.9985';
var ARROW_HEAD_RIGHT = 'M26.9984 5.25L33.7469 11.9985L26.9984 18.7469';
var ARROW_HEAD = 'M11.9984 5.25L18.7469 11.9985L11.9984 18.7469';
var ArrowRight = function ArrowRight(_ref) {
  var state = _ref.state,
    props = _objectWithoutProperties(_ref, _excluded$1);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasHovered = _useState2[0],
    setHasHovered = _useState2[1];
  useEffect(function () {
    if (state === 'hover') setHasHovered(true);
  }, [state]);
  return jsx("svg", _objectSpread2(_objectSpread2({
    overflow: "visible",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.75,
    viewBox: "2 2 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: jsxs(MotionConfig, {
      transition: {
        duration: 0.25,
        times: [0, 0.3, 1]
      },
      children: [jsx(motion$1.path, {
        animate: hasHovered ? {
          d: state === 'hover' ? [null, ARROW_BODY_STRETCH, ARROW_BODY_RIGHT] : [null, ARROW_BODY_STRETCH, ARROW_BODY]
        } : undefined,
        d: ARROW_BODY
      }), jsx(motion$1.path, {
        animate: hasHovered ? {
          d: state === 'hover' ? [null, ARROW_HEAD_RIGHT, ARROW_HEAD_RIGHT] : [null, ARROW_HEAD_RIGHT, ARROW_HEAD]
        } : undefined,
        d: ARROW_HEAD
      })]
    })
  }));
};

var _excluded = ["state"];
var ArrowUpRight = function ArrowUpRight(_ref) {
  var state = _ref.state,
    props = _objectWithoutProperties(_ref, _excluded);
  return jsxs(chakra.svg, _objectSpread2(_objectSpread2({
    strokeLinecap: "round",
    strokeLinejoin: "round",
    sx: {
      strokeWidth: state === 'hover' ? '1.3px !important' : undefined
    },
    transform: state === 'hover' ? 'rotate(-45deg) scale(1.5)' : undefined,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [jsx("path", {
      d: "M5.25 11.9985L18.7469 11.9985"
    }), jsx("path", {
      d: "M11.9984 5.25L18.7469 11.9985L11.9984 18.7469"
    })]
  }));
};

export { Button, Link, Spinner, ArrowRight as dArrowRight, ArrowUpRight as dArrowUpRight };
